export default "__VITE_PUBLIC_ASSET__99e860d0__"